import { FC } from 'react';
// Models
import { IUser } from 'models/User';
// Store
import { useSelector } from 'react-redux';
// Selectors
import { selectFilteredUsers } from 'store/user/userSelectors';
// Componenr
import { Loader, Message } from 'components/Utilities';
// 
import UsersListItem from './UsersListItem';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  sortedUsers: IUser[];
  onRequestSort: (key:string) => void;
  getClassNamesFor: (key:string) => void;
}

const UsersList:FC<Props> = ({
  // Props
  sortedUsers, onRequestSort, getClassNamesFor
}) => {
  const { t } = useTranslation();
  // State
  const users:IUser[] | null = useSelector(selectFilteredUsers);

  if ( !users ) return <Loader />;
  if ( users.length === 0 ) return <Message text={t('pages.users.noData')} />;
  return (
    <table>
      <thead>
        <tr>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('name')}`}
            onClick={() => onRequestSort('name')}
          >{t('labels.firstName')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('surname')}`}
            onClick={() => onRequestSort('surname')}
          >{t('labels.lastName')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('email')}`}
            onClick={() => onRequestSort('email')}
          >{t('labels.email')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('groups')}`}
            onClick={() => onRequestSort('groups')}
          >{t('labels.group')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('organization')}`}
            onClick={() => onRequestSort('organization')}
          >{t('labels.organization')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('licenseExpirationDate')}`}
            onClick={() => onRequestSort('licenseExpirationDate')}
          >{t('labels.expirationDate')}</th>
          <th
            className={`text-left hover:bg-gray-500 cursor-pointer ${getClassNamesFor('lastLogged')}`}
            onClick={() => onRequestSort('lastLogged')}
          >{t('labels.lastLoggedIn')}</th>
          <th
            className="text-right"
          >{t('labels.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {sortedUsers.map((user:IUser) => (
          <UsersListItem
            key={`user-item-${user._id}`}
            user={user}
          />
        ))}
      </tbody>
    </table>
  )
}

export default UsersList;
